import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
@Component({
  selector: 'app-course-evaluation-form',
  templateUrl: './course-evaluation-form.component.html',
  styleUrls: ['./course-evaluation-form.component.scss']
})
export class CourseEvaluationFormComponent implements OnInit {


  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  jobData
  learnerData
  doorEdit
  evaluationForm: any
  loading: boolean;

  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
  ) { }

  ngOnInit() {
    this.createForm()
  }




  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in Evalution form Supervisior course", changes);
    if (changes.singleLearner && changes.singleLearner.currentValue) {
      this.learnerData = changes.singleLearner.currentValue
    }

    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue
    }

    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      console.log("changes.assessmentEdit.currentValue in master", changes.assessmentEdit.currentValue)
      this.doorEdit = changes.assessmentEdit.currentValue
      this.createForm(this.doorEdit)
      console.log("assement plan edit data", this.assessmentEdit);
    }
  }





  // FORM CONTROL


  createForm(details?) {
    this.evaluationForm = new FormGroup({
      tutor: new FormControl((details && details.evaluationForm) ? details.evaluationForm.tutor : ''),
      venue: new FormControl((details && details.evaluationForm) ? details.evaluationForm.venue : ''),
      courseDate: new FormControl((details && details.evaluationForm) ? details.evaluationForm.courseDate : ''),
      matSelect1: new FormControl((details && details.evaluationForm) ? details.evaluationForm.matSelect1 : ''),
      matSelect2: new FormControl((details && details.evaluationForm) ? details.evaluationForm.matSelect2 : ''),
      matSelect3: new FormControl((details && details.evaluationForm) ? details.evaluationForm.matSelect3 : ''),
      matSelect4: new FormControl((details && details.evaluationForm) ? details.evaluationForm.matSelect4 : ''),
      matSelect5: new FormControl((details && details.evaluationForm) ? details.evaluationForm.matSelect5 : ''),
      matSelect6: new FormControl((details && details.evaluationForm) ? details.evaluationForm.matSelect6 : ''),
      matSelect7: new FormControl((details && details.evaluationForm) ? details.evaluationForm.matSelect7 : ''),
      matSelect8: new FormControl((details && details.evaluationForm) ? details.evaluationForm.matSelect8 : ''),
      text: new FormControl((details && details.evaluationForm) ? details.evaluationForm.text : ''),
      text1: new FormControl((details && details.evaluationForm) ? details.evaluationForm.text1 : ''),
      comment: new FormControl((details && details.evaluationForm) ? details.evaluationForm.comment : ''),
      name: new FormControl((details && details.evaluationForm) ? details.evaluationForm.name : ''),
      company: new FormControl((details && details.evaluationForm) ? details.evaluationForm.company : ''),
    })
  }




  // Utility
  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }



  // API CALL


  submitForm() {
    console.log("final form value", this.evaluationForm.value);
    this.loading = true
    let data = {
      learnerId: this.learnerData,
      jobId: this.jobData,
      version: true,
      details: {
        evaluationForm: this.evaluationForm.value
      }
    }
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })
  }



}
